// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._7I5mn{background-color:#fff;border-radius:2.5px;bottom:1em;-webkit-box-shadow:0 0 18px rgba(0,0,0,.2);box-shadow:0 0 18px rgba(0,0,0,.2);max-height:90%;max-width:375px;overflow-x:hidden;overflow-y:auto;padding:55px 25px 25px;position:fixed;right:1em;width:26%;z-index:2147483645}._2P59R{cursor:pointer;padding:20px;position:absolute;right:0;top:0}.FL5qV{height:10px;width:10px}._3TBR8{color:#0a385a;font-size:13px;line-height:1.5;margin-bottom:0}", ""]);
// Exports
exports.locals = {
	"cookiesBox": "_7I5mn",
	"cookiesBox__closeWrapper": "_2P59R",
	"cookiesBox__closeIcon": "FL5qV",
	"cookiesBox__content": "_3TBR8"
};
module.exports = exports;
